import { Component } from '@angular/core';

@Component({
  selector: 'app-disputes-main',
  templateUrl: './disputes-main.component.html',
  styleUrls: ['./disputes-main.component.css']
})
export class DisputesMainComponent {
english:boolean=true;
hindi:boolean=false;

ngOnInit(): void {
  const storeVal = localStorage.getItem('selectedValue');
  if (storeVal == 'english') {
    this.english = true;
    this.hindi = false;
  }
  if (storeVal == 'hindi') {

    this.english = false;
    this.hindi = true;
  }

}
}

